import { gql } from '@apollo/client';
import { UserFields } from '../fragments';

const UPDATE_USER_INFO = gql`
  mutation UpdateUserInfo(
    $phoneNumber: String
    $firstName: String
    $lastName: String
    $mailProvided: String
  ) {
    updateUserInfo(
      phoneNumber: $phoneNumber
      firstName: $firstName
      lastName: $lastName
      mailProvided: $mailProvided
    ) {
      user {
        ...UserFields
      }
    }
  }
  ${UserFields}
`;

export default UPDATE_USER_INFO;
